import ContactForm from './form'
import Styles from './style.module.scss'

const TITLE = 'Final Call to Action'
const DESCRIPTION = 'Powering the Next Generation with Zero-Emission Schopol Transport'

export default function Contact() {
  return (
    <div className={Styles.contact}>
      <h2>{TITLE}</h2>
      <div className={Styles.description}>{DESCRIPTION}</div>
      <div className={Styles.form}>
        <ContactForm />
      </div>
    </div>
  )
}
